import React from "react";
import PropTypes from "prop-types";
import RankingDesktop from "./RankingDesktop";

function Ranking({ app, config }) {
  return <RankingDesktop app={app} config={config} />;
}

Ranking.defaultProps = {
  app: null,
  config: {},
};

Ranking.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Ranking;
